import { postRoute } from "./client"

export interface AcquisitionTouch {
  source?: string
  medium?: string
  campaign?: string
  content?: string
  term?: string
  referrer?: string
  landingPath?: string
  clickIdType?: string
}

export const acquisitionCaptureRoute = postRoute<{ success: true }>("/api/acquisition")
